import { LineShareIos } from '@qr-front/icons/line-share-ios'
import { Checkbox } from '@qr-front/ui/components/Checkbox'
import { useAtom } from 'jotai'
import { atomWithReset, RESET } from 'jotai/utils'
import { useTranslations } from 'next-intl'
import { forwardRef, useImperativeHandle } from 'react'

import { getStore } from '@/store'
import { TTranslationFunction } from '@/types'

import { TContentFormHandle, TQrContentFormSection } from './qrContentFormTypes'

export const SHARE_IMAGES_FORM_ID = 'share-images'

export const shareImageGalleryAtom = atomWithReset(true)

export const resetShareImageGalleryForm = () => {
	getStore().set(shareImageGalleryAtom, RESET)
}

const ShareImagesForm = forwardRef<TContentFormHandle>((_, ref) => {
	const t = useTranslations()

	useImperativeHandle(
		ref,
		() => ({
			validate: () => Promise.resolve({ isValid: true }),
		}),
		[],
	)

	const [isShareEnabled, setIsShareEnabled] = useAtom(shareImageGalleryAtom)

	return (
		<fieldset>
			<Checkbox
				checked={isShareEnabled}
				onCheckedChange={(checked) => setIsShareEnabled(!!checked)}
				id="share-images"
				label={t(
					'generator__content_form_section__share_images__checkbox_label',
				)}
			/>
		</fieldset>
	)
})

ShareImagesForm.displayName = 'ShareImagesForm'

export const shareImagesFormConfig = (
	t: TTranslationFunction,
): TQrContentFormSection => ({
	id: SHARE_IMAGES_FORM_ID,
	title: t('generator__content_form_section__share_images__title'),
	description: t('generator__content_form_section__share_images__description'),
	icon: <LineShareIos />,
	Content: ShareImagesForm,
})
